import { Children, cloneElement, type ReactElement } from 'react';
import type { EventWrapperProps } from 'react-big-calendar';
import type { CalendarAppointmentEvent } from '../../Calendar.types';

interface CustomEventWrapperProps
  extends EventWrapperProps<CalendarAppointmentEvent> {
  children: ReactElement<{ style: { left?: string; width?: string } }>;
}

const EventWrapper = ({ children }: CustomEventWrapperProps) => {
  'use memo';
  // Events that are render with overlap (meaning with a left % higher
  // than 0) also receive +3px offset from RBC by default. This results
  // in weird gaps when rendering very slim events (like the availabilities).
  // Because we dont want to hijack RBC's entire render flow, we instead
  // just filter out the oddly positioned events here and adjust them
  // as needed.

  // The same also applies to the width of rendered events.

  const needsLeftOffset =
    ((children.props.style.left as string) || '').indexOf('3px') != -1;
  const needsWidthOffset =
    ((children.props.style.width as string) || '').indexOf('3px') != -1;

  if (needsLeftOffset || needsWidthOffset) {
    const newC = {
      ...children,
      props: {
        ...children.props,
        style: {
          ...children.props.style,
          ...(needsLeftOffset && {
            left: (children.props.style.left as string).replace(' + 3px', '')
          }),
          ...(needsWidthOffset && {
            width: (children.props.style.width as string).replace(' - 3px', '')
          })
        }
      }
    };

    return cloneElement(Children.only(newC));
  }

  return cloneElement(Children.only(children));
};

export default EventWrapper;
